import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Historique, HistoriqueModel } from '../models';
import { CoreService, HttpService } from '../services';

@Injectable({
  providedIn: 'root'
})

export class HistoryService {

  // liste d'historiques
  public ListHistories: Array<Historique> = new Array<Historique>();

  // Nombre d'historique
  public NbHistories: number;

  public IsLoading: boolean;

  public pageLength: number = 1;
  public pageSize: number = 10;
  public pageIndex: number = 0;
  public pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(
    protected http: HttpService,
    public indParam: CoreService
  ) { }



  public GetHistory(idPere: string): Observable<boolean> {
    this.IsLoading = true;
    const model: HistoriqueModel = new HistoriqueModel();
    model.Mode = "GET_HISTORY";
    model.pageSize = this.pageSize;
    model.pageIndex = this.pageIndex;
    model.IdPere = idPere;
    return this.http.postHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/`, model).pipe(
      map((data: HistoriqueModel) => {
        this.ListHistories = data.ListHistories;
        this.NbHistories = !data.ListHistories ? 0 : data.ListHistories.length;
        this.pageLength = data.pageLength;
        this.IsLoading = false;
        return true;
      }
      ));
  }
}

